module.exports = __webpack_public_path__ + "static/media/budget-wider.66a07684.png";